import React, { useEffect } from 'react';
import { Modal, Form, Input, Row, Col, Switch } from 'antd';

const MenuCreateForm = ({ visible, onCancel, onOk }) => {
  const [form] = Form.useForm();

  // 每次弹窗打开时重置表单
  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onOk(values);
      form.resetFields();
    } catch {}
  };

  return (
    <Modal
      title="添加一级菜单组"
      open={visible}
      onCancel={onCancel}
      onOk={handleOk}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="title" label="菜单名称" rules={[{ required: true, message: '请输入菜单名称' }]}> <Input maxLength={128} /> </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="code" label="菜单编码" rules={[{ required: true, message: '请输入菜单编码' }]}> <Input maxLength={64} /> </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="icon" label="图标"> <Input /> </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="sort" label="排序值" rules={[{ required: true, message: '请输入排序值' }]}> <Input type="number" /> </Form.Item>
          </Col>
        </Row>
        <Form.Item name="key" label="菜单访问地址"> <Input maxLength={255} /> </Form.Item>
        <Form.Item name="isHidden" label="是否隐藏" valuePropName="checked"> <Switch /> </Form.Item>
      </Form>
    </Modal>
  );
};

export default MenuCreateForm; 